import { LayoutComponent } from "@jelly/lesson";
import config from "appConfig";

const components: LayoutComponent[] = [
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "text",
        options: {
          data: "Party",
          scrollbars: false,
        },
      },
      styles: {
        justifyContent: "flex-start",
        fontSize: "12px",
        fontWeight: 700,
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "default",
          text: "original",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/original-party.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "default",
          text: "62",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/62-lightweight-party.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "default",
          text: "58",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/58-lightweight-party.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "default",
          text: "54",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/54-lightweight-party.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "default",
          text: "50",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/50-lightweight-party.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "default",
          text: "46",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/46-lightweight-party.wav`,
        },
      },
    },
  },
  {
    variant: "blockContainer",
    data: {
      block: {
        type: "audioButton",
        options: {
          icon: "cis-volume-high",
          theme: "default",
          text: "42",
          shape: "round",
          size: "small",
          url: `${config.ASSETS_URL}/05/23/principle/42-lightweight-party.wav`,
        },
      },
    },
  },
];

export default components;
